'use es6';

import { combineReducers } from 'redux';
import Notifications from 'ReduxMessenger/reducers/Notifications';
import { rootNameSpace as permissionNamespace } from 'dashboard-lib/public/permission/permission-action';
import { permissionReducer } from 'dashboard-lib/public/permission/permission-reducer';
import { namespace as teamHierarchyNamespace } from 'dashboard-lib/public/team/team-hierarchy-action';
import { teamHierarchyReducer } from 'dashboard-lib/public/team/team-hierarchy-reducer';
import { namespace as teamNamespace } from 'dashboard-lib/public/team/team-action';
import { teamReducer } from 'dashboard-lib/public/team/team-reducer';
import { namespace as usersNamespace } from 'dashboard-lib/public/users/users-action';
import { usersReducer } from 'dashboard-lib/public/users/users-reducer';
import { contentAssistanceNamespace, contentAssistanceReducer } from 'dashboard-lib/public/contentAssistance/contentAssistanceReducer';
import { recentlyUpdatedTemplatesNamespace, recentlyUpdatedTemplatesReducer } from '../SmartLibrary/redux/recentlyUpdatedTemplatesReducer';
import { userInfoNamespace, userInfoReducer } from 'dashboard-lib/public/userInfo';
import auth from './authReducer';
import dashboards from './dashboardsReducer';
import owners from './ownersReducer';
import reports from './reportsReducer';
import aiSettings from './aiSettingsReducer';
import { dashboardWidgetCountsNamespace, reduceDashboardWidgetCount } from '../actions/dashboard-widget-count';
import { favoritesNamespace, favoritesReducer } from '../redux/favorites';
import { selectedRowsNamespace, selectedRowsReducer } from '../redux/selectedRows';
import { reportCollectionTemplatesNamespace, reportCollectionTemplatesReducer } from '../redux/reportCollectionTemplates';
import lists from 'analytics-tools-lib/reducers/lists';
import resolvedReports from '../analyticsToolsBeta/reducers/resolvedReports';
import noData from '../analyticsToolsBeta/reducers/noData';
import { favoriteAssetsNamespace, favoriteAssetsReducer } from '../SmartLibrary/redux/favoritesReducer';
import { tagsNamespace, tagsReducer } from '../redux/tags';
export default combineReducers({
  auth,
  dashboards,
  owners,
  notifications: Notifications,
  reports,
  resolvedReports,
  [dashboardWidgetCountsNamespace]: reduceDashboardWidgetCount,
  [permissionNamespace]: permissionReducer,
  [teamHierarchyNamespace]: teamHierarchyReducer,
  [teamNamespace]: teamReducer,
  [usersNamespace]: usersReducer,
  [favoritesNamespace]: favoritesReducer,
  [tagsNamespace]: tagsReducer,
  [userInfoNamespace]: userInfoReducer,
  [selectedRowsNamespace]: selectedRowsReducer,
  lists,
  noData,
  [contentAssistanceNamespace]: contentAssistanceReducer,
  [reportCollectionTemplatesNamespace]: reportCollectionTemplatesReducer,
  aiSettings,
  [favoriteAssetsNamespace]: favoriteAssetsReducer,
  [recentlyUpdatedTemplatesNamespace]: recentlyUpdatedTemplatesReducer
});